/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpecialPallet
 */
export interface SpecialPallet {
    /**
     * 
     * @type {string}
     * @memberof SpecialPallet
     */
    ean?: string;
    /**
     * 
     * @type {number}
     * @memberof SpecialPallet
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof SpecialPallet
     */
    amountPerSpecialPallet?: number;
}

/**
 * Check if a given object implements the SpecialPallet interface.
 */
export function instanceOfSpecialPallet(value: object): value is SpecialPallet {
    return true;
}

export function SpecialPalletFromJSON(json: any): SpecialPallet {
    return SpecialPalletFromJSONTyped(json, false);
}

export function SpecialPalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialPallet {
    if (json == null) {
        return json;
    }
    return {
        
        'ean': json['ean'] == null ? undefined : json['ean'],
        'price': json['price'] == null ? undefined : json['price'],
        'amountPerSpecialPallet': json['amountPerSpecialPallet'] == null ? undefined : json['amountPerSpecialPallet'],
    };
}

export function SpecialPalletToJSON(json: any): SpecialPallet {
    return SpecialPalletToJSONTyped(json, false);
}

export function SpecialPalletToJSONTyped(value?: SpecialPallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ean': value['ean'],
        'price': value['price'],
        'amountPerSpecialPallet': value['amountPerSpecialPallet'],
    };
}

